import {
  GoogleAuthProvider,
  signInWithPopup,
  signOut as firebaseSignOut,
  onAuthStateChanged as firebaseOnAuthStateChanged,
} from 'firebase/auth';

import { auth } from './firebaseConfig.js';

/**
 * Thin adapter around Firebase Auth.
 *
 * Uses signInWithPopup on all platforms. Mobile Safari supports popups
 * when triggered by a user gesture (click). The redirect flow has
 * Safari ITP issues that make it unreliable.
 */
class FirebaseAuthAdapter {

  /** Sign in with Google via popup. */
  async signInWithGoogle() {
    const provider = new GoogleAuthProvider();
    const result = await signInWithPopup(auth, provider);
    return result.user;
  }

  async signOut() {
    return firebaseSignOut(auth);
  }

  getCurrentUser() {
    return auth.currentUser;
  }

  onAuthStateChanged(callback) {
    return firebaseOnAuthStateChanged(auth, callback);
  }

  /** No-op — kept for API compatibility with main.js */
  async waitForRedirect() {
    return Promise.resolve();
  }
}

export const authAdapter = new FirebaseAuthAdapter();
